import React, { useState, useEffect } from 'react';

const ProductBreadcrumbs = ({ product }) => {
  const [collection, setCollection] = useState(null);

  useEffect(() => {
    const url = window.location.href;
    const string = '/collections/';

    if (url.includes(string)) {
      const handle = url.split(string)[1].split('/')[0];

      setCollection({
        title: handle.replace('-', ' '),
        handle: handle,
        link: `/collections/${handle}`,
      });
    }
  }, []);

  return (
    <>
      {product && (
        <div className="Nav Nav--breadcrumbs" role="navigation" aria-label="breadcrumbs">
          <div className="Nav__item">
            <a href="/" title="Home">
              Home
            </a>
          </div>
          {collection ? (
            <div className="Nav__item">
              <a href={collection.link} title={collection.title}>
                {collection.title}
              </a>
            </div>
          ) : null}
          <div className="Nav__item">
            <span>{product.title}</span>
          </div>
        </div>
      )}
    </>
  );
};

export default ProductBreadcrumbs;
